<template>
  <div class="ficha-mapa ficha-edafologia">
    <div class="encabezado">Tipos de suelo (Edafología)</div>
    <div class="contenedor">
      <Carousel
        class="oculto-escritorio"
        :altura="300"
        :id="'carrusel-avistamiento'"
        :lista="lista_fotos"
      />
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto oculto-movil">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha8/1_Edafologia.jpg"
              alt=""
            />
            <div class="degradado-edafologia"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Suelo superficial</p>
          </div>
          <div class="ficha-cuerpo">
            <ul>
              <li>
                La zona cuenta con un
                <b>suelo único en el mundo (hidrogel hipersalino),</b> que puede
                desestructurarse y desaparecer si continúa el desecamiento del
                lago.
              </li>
              <li>
                Tiene presencia de <b>jaboncillo negro</b> que es el
                <b
                  >material lacustre con la mayor extensión de la base del
                  lago</b
                >
                (4,700 ha); presenta altos contenidos de sulfuro de hierro
                amorfo (que da un color similar al huevo podrido), además de
                metales pesados como cobre, plomo, incluso arsénico (Gutiérrez y
                Ortiz, 2013).
              </li>
              <li>
                A pesar de ser un lago desecado,
                <b
                  >sus terrenos siguen conservando humedad, lo que los hace
                  inestables a la construcción de obras de ingeniería</b
                >; se comportan como una gran gelatina con riesgos muy altos a
                la actividad sísmica de la zona y con una salinidad mayor a la
                del agua de mar.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="ficha-espacio"></div>

      <div class="col">
        <div class="ficha-foto oculto-movil ficha-foto-full-height">
          <img
            class="foto"
            src="@/assets/fichas-diagnostico/ficha8/2_Edafologia.jpg"
            alt=""
          />
          <div class="degradado-edafologia"></div>
          <div class="cuadro-contraste"></div>
          <p class="pie-foto">Perfil de suelo</p>
        </div>
      </div>

      <div class="ficha-espacio"></div>

      <div class="col">
        <div class="ficha-foto oculto-movil ficha-foto-half-height">
          <img
            class="foto"
            src="@/assets/fichas-diagnostico/ficha8/3_Edafologia.jpg"
            alt=""
          />
          <div class="degradado-edafologia"></div>
          <div class="cuadro-contraste"></div>
          <p class="pie-foto">Formación de grietas</p>
        </div>
        <div class="ficha-foto oculto-movil ficha-foto-half-height">
          <img
            class="foto"
            src="@/assets/fichas-diagnostico/ficha8/4_Edafologia.jpg"
            alt=""
          />
          <div class="degradado-edafologia"></div>
          <div class="cuadro-contraste"></div>
          <p class="pie-foto">Excavación de perfil</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/base/Carousel.vue";

export default {
  name: "Edafologia",
  components: {
    Carousel,
  },
  data() {
    return {
      lista_fotos: [
        [
          require("@/assets/fichas-diagnostico/ficha8/1_Edafologia.jpg"),
          "Suelo superficial",
        ],
        [
          require("@/assets/fichas-diagnostico/ficha8/2_Edafologia.jpg"),
          "Perfil de suelo",
        ],
        [
          require("@/assets/fichas-diagnostico/ficha8/3_Edafologia.jpg"),
          "Formación de grietas",
        ],
        [
          require("@/assets/fichas-diagnostico/ficha8/4_Edafologia.jpg"),
          "Excavación de perfil",
        ],
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@media (min-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio {
    display: none;
  }
  div.oculto-movil {
    display: inherit;
  }
}
@media (max-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio {
    display: inherit;
  }
  div.oculto-movil {
    display: none;
  }
}
.carrusel-cuerpo {
  padding: 0 30px;
}
</style>